export default __webpack_public_path__ + "static/media/051-plus.183a1616.svg";